import { Grid } from '@material-ui/core'
import React from 'react'
import './Banner2.css'

function Banner2() {
    return (
        <Grid  >
          <img style={{paddingBottom:'30px'}} className="responsive-banner" src="https://www.rtbhouse.com/wp-content/uploads/2016/11/banner.jpg" alt=''/>
      </Grid>
    )
}

export default Banner2
